import { Navigate } from 'react-router-dom';
import useAuthStore from '@/store/authStore';
import { getDefaultRouteByRole } from '@/routes/utils';

/**
 * Protected Route Component
 * Redirects to login if user is not authenticated
 */
const ProtectedRoute = ({ children, roles = [] }) => {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (roles.length > 0) {
    const currentRole = user?.role?.toString().toUpperCase();
    const allowedRoles = roles.map((role) => role.toString().toUpperCase());

    if (!currentRole || !allowedRoles.includes(currentRole)) {
      return <Navigate to={getDefaultRouteByRole(user?.role)} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
